import React, { createContext, useContext, useSyncExternalStore } from 'react'
import type { LookupSiteResponsePayload } from '../agent/messages'
import { siteInfoStore } from './store'

const SiteInfoContext = createContext<LookupSiteResponsePayload | null>(null)

type Props = {
  children: React.ReactNode
}

export const SiteInfoProvider = ({ children }: Props) => {
  const siteInfo = useSyncExternalStore(
    siteInfoStore.subscribe,
    siteInfoStore.get,
    siteInfoStore.get,
  )

  return (
    <SiteInfoContext.Provider value={siteInfo}>
      {children}
    </SiteInfoContext.Provider>
  )
}

export const useSiteInfo = (): LookupSiteResponsePayload | null => {
  return useContext(SiteInfoContext)
}
